import instanceQuery from 'graphql/queries/product/LuckinsConfigQuery.graphql';
import defaultQuery from 'graphql/queries/product/LuckinsConfigDefault.graphql';
import mutationQuery from 'graphql/mutations/product/LuckinsConfigMutation.graphql';
import fragment from 'graphql/fragments/product/LuckinsConfigFragment.graphql';
import { ALLOW_EDIT, ALLOW_VIEW } from '../../../utils/OperationPermissions';

const LuckinsConfig = {
  type: 'LuckinsConfig',
  title: 'Luckins Configuration',
  formTitle: 'Luckins Configuration',
  formUrl: '/Products/Luckins/LuckinsConfig/',
  instance: instanceQuery,
  default: defaultQuery,
  update: mutationQuery,
  fragment,
  screenReference: 'LUCKINS_CONFIGURATION',
  operations: ALLOW_EDIT | ALLOW_VIEW,
};

export default LuckinsConfig;
